import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const spinnerVariants = cva(
  'rounded-full border-2 border-current animate-spin',
  {
    variants: {
      size: {
        sm: 'w-4 h-4 border-2',
        md: 'w-6 h-6 border-2',
        lg: 'w-8 h-8 border-3',
        xl: 'w-12 h-12 border-4',
      },
      variant: {
        default: 'border-primary-500 border-t-transparent',
        secondary: 'border-gray-400 border-t-transparent',
        error: 'border-error border-t-transparent',
      },
    },
    defaultVariants: {
      size: 'md',
      variant: 'default',
    },
  }
);

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'secondary' | 'error';
}

const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="status"
        aria-label="Chargement..."
        className={cn(spinnerVariants({ size, variant }), className)}
        {...props}
      />
    );
  }
);

Spinner.displayName = 'Spinner';

export { Spinner };